import { FC } from 'react'
import { colorPallet } from '../../styles/colors'
type SendIconProps = {
  disabled: boolean
}
export const SendIcon: FC<SendIconProps> = (props) => {
  const { disabled } = props
  const colorCode = disabled ? '#cdcdcd' : colorPallet.primary

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17" width="17px">
      <path
        fill={colorCode}
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
        d="M358.531 355.822l-15.32-7.76c-.687-.22-1.344.158-1.188.947l2.189 5.93 9.379 1.546-9.379 1.576-2.189 5.93c-.156.79.5 1.167 1.189.947l15.32-7.79c.624-.253.624-1.041 0-1.325v-.001z"
        transform="translate(-342 -348)"
      ></path>
    </svg>
  )
}
